import { Stack, useMantineTheme } from '@mantine/core'
import { useDisclosure, useMediaQuery } from '@mantine/hooks'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useAuth } from '@/plugins/auth'
import { BodyStack } from '@/styled/components'

import ModalSkeleton from '../Modals/ModalSkeleton'
import ExportPrivKeyModal from '../Modals/Settings/ExportPrivKeyModal'
import AccountManagement from './AccountManagement'
import GeneralPreferences from './GeneralPreferences'

const Component: React.FC = () => {
  const { t } = useTranslation()
  const theme = useMantineTheme()
  const { address } = useAuth()
  const [opened, { open, close }] = useDisclosure(false)
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`)
  const isMetamask = localStorage.getItem('Web3Auth-cachedAdapter') === 'metamask'

  const privKey = () => {
    if (isMetamask) {
      window.open(
        'https://support.metamask.io/hc/en-us/articles/360015289632-How-to-export-an-account-s-private-key',
        '_blank'
      )
    } else {
      open()
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <BodyStack>
      {address && (
        <Stack style={{ gap: '40px', width: 'fit-content' }}>
          <GeneralPreferences isMobile={isMobile as boolean} />
          <AccountManagement
            privKey={privKey}
            isMobile={isMobile as boolean}
            isMetamask={isMetamask}
          />
        </Stack>
      )}
      <ModalSkeleton
        opened={opened}
        onClose={close}
        title={t('components.settings.exportPrivateKey', 'Export Private Key')}
        size="420px"
      >
        <ExportPrivKeyModal close={close} />
      </ModalSkeleton>
    </BodyStack>
  )
}
Component.displayName = 'UserSettings'

// eslint-disable-next-line import/prefer-default-export
export { Component }
